module.exports = __webpack_public_path__ + "media/assets/images/blog/POST-LEANLINK-0116-small-2069b2a2336366f15c1d488079118b96.png";